import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '../views/MainLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: MainLayout,
    redirect: '/wind',
    children: [
      {
        path: 'wind',
        name: 'WindHome',
        component: () => import(/* webpackChunkName: "WindHome" */ '../views/WindHome.vue')
      },
      {
        path: 'solar',
        name: 'SolarHome',
        component: () => import(/* webpackChunkName: "SolarHome" */ '../views/SolarHome.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
